import { Typography, SystemIcon, Box } from '@wishket/design-system';

import { twJoin } from 'tailwind-merge';

import { ShareIconProps } from './ShareBox.types';

export const ShareIcon = ({ name, icon, onClick }: ShareIconProps) => (
  <Box
    className="flex w-fit cursor-pointer items-center gap-2 px-4 py-3"
    onClick={onClick}
  >
    <SystemIcon
      name={icon}
      className={twJoin('size-4', icon === 'medium_link' && 'text-w-gray-600')}
    />
    <Typography variant="body1" className="text-w-gray-600">
      {name}
    </Typography>
  </Box>
);
